export default "__VITE_ASSET__CqqRZ_Ph__"